"use client";
import { j as m } from "./jsx-runtime-CJ-St4mQ.mjs";
import { useMemo as h, useCallback as f, forwardRef as g } from "react";
import { t as y } from "./tv.config-BuYIgndg.mjs";
const v = y({
  base: "Divider__root shrink-0 bg-gray-300 border-none",
  variants: {
    orientation: {
      horizontal: "Divider__horizontal w-full h-[1px] my-2",
      vertical: "Divider__vertical min-h-full h-auto w-[1px] mx-2"
    }
  },
  defaultVariants: {
    orientation: "horizontal"
  }
}), D = /* @__PURE__ */ new Set([
  "id",
  "type",
  "style",
  "title",
  "role",
  "tabIndex",
  "htmlFor",
  "width",
  "height",
  "abbr",
  "accept",
  "acceptCharset",
  "accessKey",
  "action",
  "allowFullScreen",
  "allowTransparency",
  "alt",
  "async",
  "autoComplete",
  "autoFocus",
  "autoPlay",
  "cellPadding",
  "cellSpacing",
  "challenge",
  "charset",
  "checked",
  "cite",
  "class",
  "className",
  "cols",
  "colSpan",
  "command",
  "content",
  "contentEditable",
  "contextMenu",
  "controls",
  "coords",
  "crossOrigin",
  "data",
  "dateTime",
  "default",
  "defer",
  "dir",
  "disabled",
  "download",
  "draggable",
  "dropzone",
  "encType",
  "enterKeyHint",
  "for",
  "form",
  "formAction",
  "formEncType",
  "formMethod",
  "formNoValidate",
  "formTarget",
  "frameBorder",
  "headers",
  "hidden",
  "high",
  "href",
  "hrefLang",
  "httpEquiv",
  "icon",
  "inputMode",
  "isMap",
  "itemId",
  "itemProp",
  "itemRef",
  "itemScope",
  "itemType",
  "kind",
  "label",
  "lang",
  "list",
  "loop",
  "manifest",
  "max",
  "maxLength",
  "media",
  "mediaGroup",
  "method",
  "min",
  "minLength",
  "multiple",
  "muted",
  "name",
  "noValidate",
  "open",
  "optimum",
  "pattern",
  "ping",
  "placeholder",
  "poster",
  "preload",
  "radioGroup",
  "referrerPolicy",
  "readOnly",
  "rel",
  "required",
  "rows",
  "rowSpan",
  "sandbox",
  "scope",
  "scoped",
  "scrolling",
  "seamless",
  "selected",
  "shape",
  "size",
  "sizes",
  "slot",
  "sortable",
  "span",
  "spellCheck",
  "src",
  "srcDoc",
  "srcSet",
  "start",
  "step",
  "target",
  "translate",
  "typeMustMatch",
  "useMap",
  "value",
  "wmode",
  "wrap"
]), P = /* @__PURE__ */ new Set([
  "onCopy",
  "onCut",
  "onPaste",
  "onLoad",
  "onError",
  "onWheel",
  "onScroll",
  "onCompositionEnd",
  "onCompositionStart",
  "onCompositionUpdate",
  "onKeyDown",
  "onKeyPress",
  "onKeyUp",
  "onFocus",
  "onBlur",
  "onChange",
  "onInput",
  "onSubmit",
  "onClick",
  "onContextMenu",
  "onDoubleClick",
  "onDrag",
  "onDragEnd",
  "onDragEnter",
  "onDragExit",
  "onDragLeave",
  "onDragOver",
  "onDragStart",
  "onDrop",
  "onMouseDown",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp",
  "onPointerDown",
  "onPointerEnter",
  "onPointerLeave",
  "onPointerUp",
  "onSelect",
  "onTouchCancel",
  "onTouchEnd",
  "onTouchMove",
  "onTouchStart",
  "onAnimationStart",
  "onAnimationEnd",
  "onAnimationIteration",
  "onTransitionEnd"
]), u = /^(data-.*)$/, M = /^(aria-.*)$/, p = /^(on[A-Z].*)$/;
function b(o, a = {}) {
  const {
    labelable: n = !0,
    enabled: t = !0,
    propNames: i,
    omitPropNames: r,
    omitEventNames: s,
    omitDataProps: l,
    omitEventProps: d
  } = a, c = {};
  if (!t)
    return o;
  for (const e in o)
    r != null && r.has(e) || s != null && s.has(e) && p.test(e) || p.test(e) && !P.has(e) || l && u.test(e) || d && p.test(e) || (Object.prototype.hasOwnProperty.call(o, e) && (D.has(e) || n && M.test(e) || i != null && i.has(e) || u.test(e)) || p.test(e)) && (c[e] = o[e]);
  return c;
}
function w(o) {
  const a = b(o, {
    enabled: typeof o.elementType == "string"
  });
  let n;
  return o.orientation === "vertical" && (n = "vertical"), o.elementType !== "hr" ? {
    separatorProps: {
      ...a,
      role: "separator",
      "aria-orientation": n
    }
  } : { separatorProps: a };
}
function C(o) {
  const { component: a, className: n, orientation: t, ...i } = o;
  let r = a || "hr";
  r === "hr" && t === "vertical" && (r = "span");
  const { separatorProps: s } = w({
    elementType: typeof r == "string" ? r : "hr",
    orientation: t
  }), l = h(
    () => v({
      orientation: t,
      className: n
    }),
    [t, n]
  ), d = f(
    (c = {}) => ({
      className: l,
      role: "separator",
      "data-orientation": t,
      ...s,
      ...i,
      ...c
    }),
    [l, t, s, i]
  );
  return { Component: r, getDividerProps: d };
}
const S = g((o, a) => {
  const { Component: n, getDividerProps: t } = C({ ...o });
  return /* @__PURE__ */ m.jsx(n, { ref: a, ...t() });
});
S.displayName = "Divider";
export {
  S as default
};
